import axios from "axios";

export default function checkSnAssignAvailability(payload) {
  return new Promise((resolve, reject) =>
    axios
      .post(
        "/serialnumber/system-admin/api/v1/serialnumber/check-sn-availability",
        {
          branchUuid: payload.branchUuid,
          isSn: payload.isSn,
          ranges: payload.ranges,
          format: payload.format,
        }
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
